import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { manualContentListFailure, manualContentListSuccess } from '../../actions/manualVerificationActions/manualContentListActions';

function* manualContentList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.manualContentList,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("MANUAL_CONTENT_LIST_SUCCESS status :", response.data.status);
        console.log("MANUAL_CONTENT_LIST_SUCCESS data :", response.data.response);
        console.log("MANUAL_CONTENT_LIST_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            manualContentListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("MANUAL_CONTENT_LIST_FAILURE status :", error?.response?.status);
        console.log("MANUAL_CONTENT_LIST_FAILURE data:", error?.response?.data);
        console.log("MANUAL_CONTENT_LIST_FAILURE error :", error);
        console.log('====================================');
        yield put(manualContentListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* manualContentListSaga() {
    yield takeLatest(actionTypes.MANUAL_CONTENT_LIST_REQUEST, manualContentList);
}

export default manualContentListSaga;
